import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { RegraTributariaIsSectionComponent } from './sections/is-section/regra-tributaria-is-section.component';

/**
 * Aba Imposto Seletivo. A estrutura de campos (CST, cClassTrib, alíquota e alíquota ad rem)
 * já é persistida de ponta a ponta, mas os controles ficam desabilitados nesta fase: o IS só
 * entra em vigor a partir de 2027 (art. 490 da LC 214/2025), então o usuário só visualiza.
 */
@Component({
    selector: 'app-regra-tributaria-is-tab',
    standalone: true,
    imports: [CommonModule, AtivacaoSectionCardComponent, AlertCardComponent, RegraTributariaIsSectionComponent],
    templateUrl: './regra-tributaria-is-tab.component.html',
    styleUrl: './regra-tributaria-is-tab.component.css',
})
export class RegraTributariaIsTabComponent implements OnInit {
    @Input({ required: true }) form!: FormGroup;

    public get isForm(): FormGroup {
        return this.form.get('impostoSeletivo') as FormGroup;
    }

    public get ativacaoControl(): FormControl {
        return this.isForm.get('isAtivo') as FormControl;
    }

    ngOnInit(): void {
        // O IS só entra em vigor a partir de 2027: os campos existem e são salvos, mas o
        // usuário ainda não pode editá-los nesta tela.
        this.isForm.disable({ emitEvent: false });
    }
}
